const actions = {
  LOAD_CONFIG: 'config/LOAD_CONFIG',
  SET_CONFIG_STATE: 'config/SET_CONFIG_STATE',
  // LOGIN: 'system/LOGIN',
  // LOAD_CURRENT_ACCOUNT: 'user/LOAD_CURRENT_ACCOUNT',
  // LOGOUT: 'user/LOGOUT',
}

export default actions
